import styled from 'styled-components';

export const SpinnerWrapper = styled.div`
  width: 40%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 20% auto;
`;
export const LoadingSpinner = styled.div`
  width: 4rem;
  height: 4rem;
  border-radius: 5rem !important;
  border: 0.5rem solid var(--secondary);
  border-top: 0.5rem solid var(--primary);
  border-image: linear-gradient(var(--primary)) 1;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
